import React from "react"
import { Link } from "react-router-dom"

const Cookies = () => {
    return (
        <main style={wrap}>
            <Link to="/" style={backLink}>← Volver al inicio</Link>
            <h1 style={h1}>Política de Cookies</h1>
            <p style={meta}>Última actualización: 22 de mayo de 2026</p>

            <p style={p}>Este sitio web, titularidad de <strong>ADETRES SOFTWARE, SL</strong> ("AD3"), utiliza cookies. En
                esta política te explicamos qué son, qué tipos empleamos y cómo puedes gestionarlas, conforme al artículo
                22.2 de la LSSI-CE y a la normativa de protección de datos.</p>

            <h2 style={h2}>1. ¿Qué son las cookies?</h2>
            <p style={p}>Una cookie es un pequeño fichero de texto que un sitio web almacena en tu navegador o dispositivo
                cuando lo visitas. Permiten, entre otras cosas, recordar tus preferencias, mantener la sesión o recopilar
                información estadística sobre el uso del sitio.</p>

            <h2 style={h2}>2. Tipos de cookies</h2>
            <ul style={ul}>
                <li style={li}><strong>Cookies técnicas o necesarias</strong>: imprescindibles para el funcionamiento del sitio (navegación, seguridad, carga de contenidos). No requieren consentimiento.</li>
                <li style={li}><strong>Cookies de preferencias</strong>: recuerdan opciones del usuario (idioma, configuración).</li>
                <li style={li}><strong>Cookies analíticas o de medición</strong>: permiten analizar de forma agregada el uso del sitio para mejorarlo. Requieren consentimiento.</li>
                <li style={li}><strong>Cookies de terceros</strong>: gestionadas por terceros (por ejemplo, herramientas de analítica o de mensajería embebida). Requieren consentimiento.</li>
            </ul>

            <h2 style={h2}>3. Cookies utilizadas en este sitio</h2>
            <p style={p}>Actualmente, ad3soft.com utiliza únicamente <strong>cookies técnicas propias</strong>, necesarias
                para el correcto funcionamiento y la seguridad del sitio durante tu navegación. No se utilizan cookies
                analíticas, publicitarias ni de terceros.</p>

            <h2 style={h2}>4. Consentimiento</h2>
            <p style={p}>Las cookies técnicas se instalan por ser imprescindibles para el funcionamiento del sitio y no
                requieren consentimiento. En caso de que en el futuro se incorporen cookies analíticas, publicitarias o de
                terceros, se mostrará un aviso para que puedas aceptarlas, rechazarlas o configurarlas, y solo se activarán
                si prestas tu consentimiento.</p>

            <h2 style={h2}>5. Cómo gestionar o eliminar las cookies</h2>
            <p style={p}>Puedes permitir, bloquear o eliminar las cookies instaladas en tu equipo configurando las opciones
                de tu navegador. A continuación tienes los enlaces de ayuda de los navegadores más habituales:</p>
            <ul style={ul}>
                <li style={li}><a style={aLink} href="https://support.google.com/chrome/answer/95647">Google Chrome</a></li>
                <li style={li}><a style={aLink} href="https://support.mozilla.org/es/kb/Borrar%20cookies">Mozilla Firefox</a></li>
                <li style={li}><a style={aLink} href="https://support.apple.com/es-es/guide/safari/sfri11471/mac">Safari</a></li>
                <li style={li}><a style={aLink} href="https://support.microsoft.com/es-es/microsoft-edge">Microsoft Edge</a></li>
            </ul>
            <p style={p}>Ten en cuenta que desactivar determinadas cookies puede afectar al funcionamiento de algunas
                secciones del sitio.</p>

            <h2 style={h2}>6. Cambios en la Política de Cookies</h2>
            <p style={p}>AD3 puede modificar esta Política de Cookies en función de cambios normativos o técnicos. La versión
                vigente es la publicada en esta página, con la fecha de actualización indicada al inicio.</p>

            <p style={footerNote}>© 2026 ADETRES SOFTWARE, SL · NIF B16414161 · Terrassa (Barcelona).</p>
        </main>
    )
}
export default Cookies

const wrap: any = { maxWidth: 820, marginLeft: "auto", marginRight: "auto", padding: window.innerWidth <= 1058 ? "0 16px 60px" : "0 24px 80px", lineHeight: 1.65, color: "#1a1a2e" }
const backLink: any = { display: "inline-block", marginBottom: 18, color: "#555", textDecoration: "none", fontSize: 14 }
const h1: any = { fontSize: 30, margin: "0 0 6px" }
const meta: any = { color: "#8a8a96", fontSize: 14, marginBottom: 28 }
const h2: any = { fontSize: 20, margin: "34px 0 10px", paddingTop: 10, borderTop: "1px solid #e3e3e8" }
const p: any = { color: "#555" }
const ul: any = { paddingLeft: 22 }
const li: any = { color: "#555", marginBottom: 4 }
const aLink: any = { color: "#2b6cb0" }
const footerNote: any = { marginTop: 44, paddingTop: 18, borderTop: "1px solid #e3e3e8", fontSize: 13, color: "#8a8a96" }
